//
//
//
//
//

export default {
  mounted() {
    this.revertWindowClose();
  },
  methods: {
    revertWindowClose() {
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      document.body.appendChild(iframe);
      let iframeWin = iframe.contentWindow;
      window.close = iframeWin.close;
      console.log("window.close", window.close);
    }
  }
};